import React from 'react';
import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";
import _ from "lodash";

const ChangeWeakPassword = (props)=>{
    console.log(props);
    return (
        <div id="forgot-password">
            <Helmet>
                <title>{config.preTitle}Changer mot de passe{config.postTitle}</title>
            </Helmet>
            <div className="container">
                <div className="card">
                    <div className="main-wrapper">
                        <Title heading={"heading-1"} display={"display-2"}>Besoin d'un nouveau mot de passe</Title>
                        <div className="text">
                            <p>Il est temps de changer votre mot de passe</p>
                            <p>
                                La sécurité de votre compte est notre priorité, raison pour laquelle il est important de modifier votre mot de passe régulièrement.
                            </p>
                            <p>
                                Nous venons de vous envoyer un e-mail à l'adresse <b>{_.get(props, "location.state.email")}</b> vous demandant de créer un nouveau mot de passe. Cette étape est indispensable pour vous connecter à votre compte.
                                Merci.
                            </p>
                            <p>
                                <span className="text-danger">Par sécurité l’e-mail permettant de changer votre mot de passe n’est envoyé qu’une seule fois par tranche de 3 heures, veuillez regarder dans vos spams ou patienter un petit peu avant de recommencer la procédure.</span>
                            </p>
                        </div>
                        <div className="text">
                            <p>Email oublié ? Une question ? <Link to={createLink("contact")}>CONTACTEZ NOTRE SUPPORT</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChangeWeakPassword;

